import { IApplicationState } from '../../types/store';
import { IHint } from '../../types/village';

export const selectHint = (state: IApplicationState): IHint | null => {
  return state.villageList.hint || null;
};
